import animateScrollTo from 'animated-scroll-to';

export const ScrollToHeightDown = () => {
  const buttons = document.querySelectorAll('.js--scroll-more');

  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      const parent = this.parentNode;
      const parentHeight = parent.offsetHeight;
      const topOffset = parent.offsetTop;

      animateScrollTo(parentHeight + topOffset, {
        speed: 750,
      });
    });
  });
}
